export default __webpack_public_path__ + "static/beads-401b97cbb51c3f54061a811dbecbe7ca.png";